<script>
    import { readOnly, questionType, lang } from "../scripts/stores";
    import DetailsModal from "./DetailsModal.svelte";

    export let question = {}
    export let page = 1;
    export let index;

    let savedValue = 0;
    let isSkipped = false;
    let selected = question.value === 0 ? "no" : "yes";
    let open = false;

    function handleValue() {
        if(selected === "no") {
            question.value = 0;
        }
        else if(selected === "yes") {
            question.value = 10;
        }
    }

    $: if(question.skip) { 
        savedValue = question.value;
        question.value = 0;
        isSkipped = true;
    }
    else {
        if(isSkipped && !question.skip) { 
            question.value = savedValue; 
            isSkipped = false;
        }
    }

</script>

<style>
    .question {
        position: relative;
        margin-bottom: 3rem;
        width: 100%;
        border-left: 6px solid var(--bg-color); 
        padding-left: 1rem;
    }
    .title {
        font-weight: 500; 
        font-size: 18px;
        margin-bottom: 1.2rem;
    }
    .radio-select {
        width: 120px;
        max-width: 48%;
        align-items: flex-start;
    }
    .r-input {
        width: 100%;
        -webkit-appearance: auto !important;
    }
    .r-label { 
        display: none;
    }
    .range-info {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
    }
    span {
        position: relative;
        vertical-align: top;
        top: .3rem;
        left: 0;
        font-weight: 400;
        font-size: 14px;
    }
    .skip-container {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }
    .disabled {
        background: rgba(0, 0, 0, .03);
        /* opacity: .65; */
    }
</style>

{#if page === question.page}
    <div class="question {question.skip ? "disabled" : ""}" data-name="question">
        <p class="title"> { index }. { question.title } </p>

        {#if $questionType === "normal"}

            <div class="radio-container">
                <label class="cursor-pointer label radio-select">
                    <span class="label-text">{ $lang === "fi" ? "Ei" : "No" }</span> 
                    <input type="radio" name="radio-{question.id}" 
                           class="radio" value={ question.type === 0 ? "no": "yes" } 
                           bind:group={ selected } disabled={ question.skip }
                           on:change={ handleValue }
                    />        
                </label>
        
                <label class="cursor-pointer label radio-select">
                    <span class="label-text">{ $lang === "fi" ? "Kyllä" : "Yes" }</span> 
                    <input type="radio" name="radio-{question.id}" 
                           class="radio" value={ question.type === 0 ? "yes": "no" } 
                           bind:group={ selected } disabled={ question.skip }
                           on:change={ handleValue }
                    />        
                </label>
            </div>

            {#if selected === "yes"}
                <p class="bold" style="margin: 1rem 0; font-weight: 500;">
                    { $lang === "fi" ? "Arvioin aistikuorman määrää" : "How much sensory overload this causes?" }
                </p>

                <label class="r-label" for={ question.id }>{ question.title }</label>
                <input type="range" class="range range-primary range-auto r-input" 
                    step="5" id={ question.id } 
                    min="10"
                    max="100"
                    bind:value={ question.value } 
                    disabled={ $readOnly || question.skip } readonly={ $readOnly || question.skip } 
                />

                <div class="range-info">
                    <span>{ $lang === "fi" ? "Vähäinen" : "Little" }</span>
                    <span>{ $lang === "fi" ? "Suuri" : "Very much" }</span>
                </div>
            {/if}
        {/if}

        {#if question.canSkip}
            <div class="skip-container">
                <label for="skip-id-{question.id}" style="font-size: 14px">
                    {#if question.skip}
                        {$lang === "fi" ? "Palauta kysymys" : "Show question"}
                    {:else}
                        {$lang === "fi" ? "Ohita kysymys" : "Skip question"}
                    {/if}
                </label>
                <input id="skip-id-{question.id}" type="checkbox" class="checkbox checkbox" 
                       style="margin-left: .5rem;" bind:checked={ question.skip }
                />
            </div>
        {/if}

        <div class="skip-container">
            <button class="btn { question.details ? "btn-primary" : "btn-ghost" } btn-sm" on:click={ () => open = true } disabled={ question.skip ? true : false }>
                {#if question.details}
                    { $lang === "fi" ? "Muokkaa muistiinpanoa" : "Edit notes"}
                {:else}
                    { $lang === "fi" ? "Lisää muistiinpano +" : "Add notes +"}
                {/if}
            </button>
        </div>
    </div>
{/if}

<DetailsModal bind:open bind:details={ question.details } title={ question.title } />
